import React, { useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, Row, Col } from "reactstrap";
import { isBoolean } from "lodash";
import HoverImage from "react-hover-image/build";
import { invoiceColumns } from "utils/columns";
import ReactStrapTable from "components/reactStrapTable";
import EyeIcon from "assets/icon/icon-icon-options-view-patient.svg";
import EyeIconHover from "assets/icon/icon-icon-options-view-patient_hover.svg";
import DownloadIcon from "assets/icon/DownloadIcon.svg";
import DownloadIconHover from "assets/icon/downloadhover.svg";
import InvoiceDetails from "components/InvoiceDetail";
import Drawer from "components/Drawer";
import useAxios from "hooks/useAxios";
import collapse from "assets/icon/collapse-icon.svg";
import EditIcon from "assets/icon/icon-icon-options-edit.svg";
import EditHoverIcon from "assets/icon/icon-icon-options-edit_hover.svg";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { ModuleAccess } from "utils/moduleaccess";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import collapseclose from "assets/icon/collapse-icon-close.svg";

const InvoiceTable = ({
  data,
  totalRecords,
  filters,
  onPageChange,
  onSearchColumnFilters = () => "",
  refetch,
  selectedCoveredEntity,
  tenantID,
  onExport,
  orgId,
  onManualSearch,
  toggleSider,
  collapseSider,
  resetFlag,
  SetResetFlag
}) => {
  const [state, updateState] = useState({
    loading: false,
    isOpen: false,
    invoiceID: "",
    invoice: {},
    filters: filters,
  });
  const API = useAxios();
  const [isOpenInvoice, setIsOpenInvoice] = useState(false);
  const [invoiceId, setInvoiceId] = useState(-1);
  const [invoiceNumber, setInvoiceNumber] = useState({});
  const { isOpen, invoice } = state;
  const [showDownload, setShowDownload] = useState(false);
  const [hasExportPermission, setHasExportPermission] = useState(false);
  const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));

  useEffect(() => {
    setState({ filters: filters });
  }, [filters]);

  useEffect(() => {
    setHasExportPermission(ModuleAccess("INV", "EXP"));
  }, []);

  useEffect(() => {
    setIsOpenInvoice(false);
  }, [orgId])
  const handleManual = async (invId) => {
    let manualFilters = selectedCoveredEntity;
    manualFilters.invoiceID = invId;
    await onManualSearch(manualFilters);
  };

  const download = async (invId) => {
    try {
      const { access_token } =
        JSON.parse(sessionStorage.getItem("pharmaforce")) || {};
      const res = await API.get(
        `/${tenantID}/Invoice/Download/${parseInt(
          invId
        )}?access_token=${access_token}`,
        {
          responseType: "blob",
        }
      );
      if (res.request.responseType === "blob") {
        window.open(res.request.responseURL);
      }
    } catch (error) { }
  };

  const previewInvoice = (invoice) => {
    if (invoice.invoiceStatusID === 230003) {
      return (
        <div className="d-flex align-items-center">
          <Button
            className="text-primary p-0 text-decoration-none"
            color="link"
            onClick={() => onHandlePreviewInvoice(invoice)}
          >
            <HoverImage
              key="EyeIcon"
              src={EyeIcon}
              hoverSrc={EyeIconHover}
              alt=""
            />
          </Button>
          <Button
            color="link"
            className="text-primary p-0 text-decoration-none"
            onClick={() => download(invoice.rcmInvoiceID)}
            hidden={!ModuleAccess("INV", "INVD")}
          >
            <HoverImage
              key="DownloadIcon"
              src={DownloadIcon}
              hoverSrc={DownloadIconHover}
              alt=""
            />
          </Button>
          <Button
            hidden={
              invoice.invoiceCycleID !== 210005 || !ModuleAccess("INV", "ED")
            }
            className="text-primary p-0 text-decoration-none"
            color="link"
            onClick={() => handleManual(invoice.rcmInvoiceID)}
          >
            <HoverImage
              key="EditIcon"
              src={EditIcon}
              hoverSrc={EditHoverIcon}
              alt=""
            />
          </Button>
        </div>
      );
    }
  };

  const onHandlePreviewInvoice = (invoice) => {
    setIsOpenInvoice(!isOpenInvoice);
    setInvoiceId(invoice.rcmInvoiceID);
    setInvoiceNumber(invoice);
  };

  let columns = [
    {
      dataField: "edit",
      text: "Options",
      width: 100,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
      cellRenderer: (row) => previewInvoice(row),
    },
    ...invoiceColumns,
  ];

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      setState({
        filters: filter,
      });
      let colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    setState({
      filters: filter,
    });
    onPageChange(filter);
  };

  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      setState({
        filters: filter,
      });
      let colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      setState({
        filters: filter,
      });
      onPageChange(filter);
    }
  };

  // const handleSort = (sortFilter) => {
  //   onPageChange({ ...filters, ...sortFilter });
  // };
  const handleSort = (filter, hasColFilter) => {
    setState({
      filters: filter,
    });
    if (hasColFilter) {
      onPageChange(filter, true);
    } else {
      onPageChange(filter);
    }
  };

  // const handleSearchColumnFilters = (colFilter) => {
  //   debugger
  //   onSearchColumnFilters(colFilter);
  // };

  const handleSearchColumnFilters = (colFilter) => {
    if (onSearchColumnFilters) {
      const filter = { ...state.filters, filters: colFilter, currentPage: 1 };
      onSearchColumnFilters(filter);
      setState({
        filters: filter,
      });
    }
  };

  const handleFilterCancel = () => {
    refetch(true);
  };

  const togglePdfModal = (hasRefresh) => {
    if (isBoolean(hasRefresh) && hasRefresh) {
      refetch();
    }
    setState({
      isOpen: !isOpen,
    });
  };
  const { filters: colFilter, backUpData } = state;

  return (
    <div>
      <div className="d-flex justify-content-between mt-3">
        <div className="">
          <h5 className="f-16 text-primary font-weight-700 m-0">Invoice Count ({totalRecords})</h5>
        </div>
        <div>
          <Row>
            <Col xs="auto p-0">
              <div
                className=""
                style={{ cursor: "pointer" }}
                onClick={toggleSider}
              >
                <img
                  collapseSider
                  src={!collapseSider ? collapse : collapseclose}
                  className=""
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>

      <hr />
      <div
        className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={data.length > 0 ? "fixed-height" : "default"}
      >
        <ReactStrapTable
          id="location-table"
          fixedColumn
          data={data}
          hasPagination
          columns={columns}
          pageSize={filters.pageSize}
          totalRecords={totalRecords}
          currentPage={filters.currentPage}
          handleSort={handleSort}
          filters={filters}
          onPageChange={onHandlePageChange}
          onPageSizeChange={onPageSizeChange}
          onFilterCancel={handleFilterCancel}
          onSearchColumnFilters={handleSearchColumnFilters}
          onExport={onExport}
          collapseSider={collapseSider}
          hasExportPermission={hasExportPermission}
          toggleSider={toggleSider}
          resetFlag={resetFlag}
          SetResetFlag={SetResetFlag}
        />

        <Drawer
          direction="end"
          title="Invoice Details"
          isOpen={isOpenInvoice}
          toggle={onHandlePreviewInvoice}
          size="lg"
        >
          <InvoiceDetails
            invoiceId={invoiceId}
            invoice={invoiceNumber}
            tenantID={tenantID}
          />
        </Drawer>

        {/* <Modal
        isOpen={isOpenInvoice}
        toggle={onHandlePreviewInvoice}
        size='xxl'
        className='xxl'
      >
        <ModalHeader toggle={onHandlePreviewInvoice}>
          Invoice Details
        </ModalHeader>
        <ModalBody>
          <InvoiceDetails invoiceId={invoiceId} invoice={invoiceNumber} tenantID={tenantID} />
        </ModalBody>
      </Modal> */}
      </div>
    </div>
  );
};

export default InvoiceTable;
